import { matchPath } from 'react-router';
import { combineReducers } from 'redux';

import { PATH } from 'constants/RoutesConstants';
import hasMore from 'modules/global/reducers/dynamoDb.hasMore';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import { GATE_DETAILS } from '../../constants';

export const detailsMatcher = ({ meta }) => meta?.target === GATE_DETAILS;

export const loadingReducer = combineReducers({
  creating: loading(types.CREATE_GATE, { global: { matcher: detailsMatcher } }),
  updating: loading(types.UPDATE_GATE, { global: { matcher: detailsMatcher } }),
  relayCheck: loading(types.RESTRICTED_ACCESS_RELAY_CHECK, { global: { matcher: detailsMatcher } }),
  fetch: loading(types.FETCH_GATE, { global: { matcher: detailsMatcher } }),
  downloadingQRCode: loading(types.DOWNLOAD_PUBLIC_QR_CODE_REQUEST, { global: { matcher: detailsMatcher } }),
  history: loading(types.FETCH_GATE_OPENINGS, { global: { matcher: detailsMatcher } }),
});

const onLocationChange = (_, { payload }) => {
  const details = matchPath(PATH.GATE_MANAGEMENT_DETAILS.path, payload.location.pathname);
  return Boolean(details) && payload.action === 'REPLACE';
};

const openingsConfig = { global: { matcher: detailsMatcher } };

export default combineReducers({
  loading: loadingReducer,
  ready: createReducer(false, {
    [LOCATION_CHANGE]: onLocationChange,
    [types.GATE_READY]: () => true,
  }),
  openings: combineReducers({
    hasMore: hasMore(types.FETCH_GATE_OPENINGS, openingsConfig),
    loading: loading(types.FETCH_GATE_OPENINGS, openingsConfig),
  }),
});
